<template>
  <div>
    <div class="categories-wrapper__none-module" :style="isUpdate && 'margin-top: 2rem'">
      <new-module
        :selected="noneModulesSelected"
        :title="adminText('workflowsAll.create_an_event_with_a_basic_registration_for_e7c22d5', 'Create an event with a basic registration form')"
        :description="adminText('workflowsAll.the_form_allows_participants_to_fill_in_their_1e9b080', 'The form allows participants to fill in their name, email address, and phone number. Additional fields can be added based on the organizer\'s preferences, offering flexibility to customize the form according to specific needs.')"
        disabled
      />
    </div>
    <div class="event-extra-modules-container">
      <h2 class="form-title">{{ workflowLabel(isUpdate ? adminText('workflowsAll.optional_modules_e5305c3', 'Optional modules') : adminText('workflowsAll.or_choose_optional_modules_4b5e9a2', 'Or choose optional modules')) }}</h2>
      <div class="categories-wrapper">
        <new-module
          :selected="form.modules.ticketing"
          :title="adminText('workflowsAll.tickets_5c622a5', 'Tickets')"
          :description="adminText('workflowsAll.enabling_tickets_gives_you_the_opportunity_to_e9a759f', 'Enabling tickets gives you the opportunity to sell tickets to your attendees.')"
          :disabled="disableEditing"
          @click="toggleModule('ticketing')"
        >
          <div v-if="form.modules.ticketing">
            <div v-if="vatObligor" class="tax-class">
              <p class="vat-text">{{ adminText('workflowsAll.add_tax_class_07bffcb', 'Add tax class') }}</p>
              <p class="description">
                {{ adminText('workflowsAll.assign_a_tax_class_that_will_apply_to_tickets_5bf052d', 'Assign a tax class that will apply to tickets for this event.') }}
              </p>
              <tax-class-options
                class="tax-class__options"
                :value="form.VATPercentage"
                :disabled="disableEditing"
                @input="setVat"
              />
              <p v-if="disableEditing" class="tax-class__hint">
                {{ adminText('workflowsAll.the_tax_class_cannot_be_changed_after_tickets_367ddbb', 'The tax class cannot be changed after tickets have been sold.') }}
              </p>
            </div>
            <new-module
              v-if="!isSportOrganization()"
              submodule
              :selected="form.modules.floorPlan"
              :title="adminText('workflowsAll.floor_plan_7bfda3b', 'FLOOR PLAN')"
              :description="adminText('workflowsAll.enabling_the_floor_plan_allows_you_to_have_mu_3a5611c', 'Enabling the floor plan allows you to have multiple sections in your venue for multiple ticket types.')"
              optional
              :disabled="disableEditing"
              @click="toggleModule('floorPlan')"
            />
            <new-module
              submodule
              :selected="form.modules.ticketPersonalization"
              :title="adminText('workflowsAll.ticket_personalization_80b4600', 'TICKET PERSONALIZATION')"
              :description="adminText('workflowsAll.process_of_assigning_each_ticket_to_a_specifi_8432ec0', 'Process of assigning each ticket to a specific individual, often requiring personal details like name or ID, to ensure security and prevent unauthorized transfers — for example, festivals often mandate that each ticket displays the attendee\'s name for entry.')"
              optional
              :disabled="disableEditing"
              @click="toggleModule('ticketPersonalization')"
            />
          </div>
        </new-module>
        <new-module
          v-if="!isSportOrganization()"
          :selected="form.modules.categoriesAndZones"
          :title="adminText('workflowsAll.categories_zones_a96a88f', 'Categories & zones')"
          :description="adminText('workflowsAll.if_you_re_managing_a_major_event_you_can_enab_cf0a879', 'If you\'re managing a major event, you can enable accreditation categories and zones to control venue access privileges.')"
          :disabled="disableEditing"
          @click="toggleModule('categoriesAndZones')"
        />
        <new-module
          :selected="form.modules.workshops"
          :title="adminText('workflowsAll.workshops_e28088b', 'Workshops')"
          :description="adminText('workflowsAll.enable_this_module_to_empower_your_attendees__539f5f3', 'Enable this module to empower your attendees by registering to multiple workshops hosted at your event.')"
          :disabled="disableEditing"
          @click="toggleModule('workshops')"
        />
        <new-module
          v-if="!isSportOrganization()"
          :selected="form.modules.mobileApp"
          :title="adminText('workflowsAll.mobile_app_7620a2b', 'Mobile app')"
          :description="adminText('workflowsAll.by_enabling_mobile_app_your_attendees_can_eas_d7b3ce1', 'By enabling mobile app, your attendees can easily access info about your event and find new connections at site.')"
          :disabled="disableEditing"
          @click="toggleModule('mobileApp')"
        >
          <div v-if="form.modules.mobileApp">
            <new-module
              :selected="form.modules.conferenceMobileApp"
              submodule
              :title="adminText('workflowsAll.conference_mobile_app_c95c49e', 'CONFERENCE MOBILE APP')"
              :description="adminText('workflowsAll.by_enabling_this_app_your_attendees_can_easil_f003462', 'By enabling this app, your attendees can easily access info about your event, find new connections at the site, and arrange meetings.')"
              :disabled="disableEditing"
              @click="toggleModule('conferenceMobileApp')"
            />
            <new-module
              :selected="form.modules.expoMobileApp"
              submodule
              :title="adminText('workflowsAll.expo_mobile_app_d95d2d4', 'EXPO MOBILE APP')"
              :description="adminText('workflowsAll.designed_for_exhibitors_at_trade_shows_to_eas_d031267', 'Designed for exhibitors at trade shows to easily track visitors to their booths. By scanning a visitor\'s QR code with a mobile device, exhibitors can quickly record attendance and gather essential contact information.')"
              :disabled="disableEditing"
              @click="toggleModule('expoMobileApp')"
            />
          </div>
        </new-module>
      </div>
      <div v-if="!isUpdate" class="buttons-wrapper">
        <main-button :text="adminText('workflowsAll.cancel_1507c40', 'CANCEL')" flat depressed @click="goBack()" />
        <div class="buttons">
          <main-button flat outline @click="() => this.$emit('back')">
            <v-icon class="arrow-back">arrow_back</v-icon>
            <span>{{ adminText('workflowsAll.back_61bb8d2', 'back') }}</span>
          </main-button>
          <main-button :text="adminText('workflowsAll.create_event_6f1d19d', 'CREATE EVENT')" :disabled="submittingForm" @click="onSubmitClick" />
        </div>
      </div>
      <div v-else class="buttons-wrapper--update">
        <main-button :text="adminText('workflowsAll.update_52c6c18', 'UPDATE')" @click="onSubmitClick" />
      </div>
      <simple-snackbar :open.sync="snackbar.open" :message-prop="workflowLabel(snackbar.messageProp)" :color="snackbar.color" />
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import newModule from './new-module.vue'
import TaxClassOptions from './tax-class-options.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'
import { EVENT_VAT_RATES } from '@/utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'event-extra-modules',
  components: {
    SimpleSnackbar,
    newModule,
    TaxClassOptions,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
    vatObligor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.initialValues,
      snackbar: { open: false, color: 'primary', messageProp: '' },
      isUpdate: !this.initialValues.generalInfo,
      vatRates: EVENT_VAT_RATES,
    }
  },
  computed: {
    noneModulesSelected() {
      return Object.values(this.form.modules).every(value => !value)
    },
  },
  watch: {
    'form.modules.ticketing'(enabled) {
      if (enabled) {
        this.ensureDefaultVat()
      }
    },
  },
  mounted() {
    if (this.form.modules && this.form.modules.ticketing) {
      this.ensureDefaultVat()
    }
  },
  methods: {
    /*toggleModule(name) {
      const modules = this.form.modules
      const disableTicketAndSubcategories = ['categoriesAndZones', 'workshops', 'mobileApp', 'conferenceMobileApp', 'expoMobileApp'].includes(
        name,
      )
      const toggleTicket = name === 'ticketing'
      this.form.modules = {
        ...modules,
        workshops:
          name === 'mobileApp' && !modules['mobileApp']
            ? true
            : !toggleTicket && modules['workshops'],
        mobileApp:
          (name === 'workshops' && modules['workshops']) || toggleTicket
            ? false
            : modules['mobileApp'],
        ticketing: disableTicketAndSubcategories ? false : modules.ticketing,
        categoriesAndZones: toggleTicket ? false : modules.categoriesAndZones,
        floorPlan:
          modules.ticketing === false || disableTicketAndSubcategories ? false : modules.floorPlan,
        // uncomment this line when adding ticket personalization feature
        // ticketPersonalization: modules.ticketing === false || disableTicketAndSubcategories ? false : modules.ticketPersonalization,
        conferenceMobileApp: (name === 'workshops' && modules['workshops']) || !modules.mobileApp || toggleTicket ? false : modules.conferenceMobileApp,
        expoMobileApp: (name === 'workshops' && modules['workshops']) || !modules.mobileApp || toggleTicket ? false : modules.expoMobileApp,
        [name]: !modules[name],
      }
    },*/
    toggleModule(name) {
      const newFormModules = { ...this.form.modules, [name]: !this.form.modules[name] }
      const toggledValue = newFormModules[name]
      if (name === 'ticketing' && toggledValue) {
        newFormModules.categoriesAndZones = false
        newFormModules.workshops = false
        newFormModules.mobileApp = false
        newFormModules.conferenceMobileApp = false
        newFormModules.expoMobileApp = false
      } else if (name === 'ticketing' && !toggledValue) {
        this.unselectTicketingSubmodules(newFormModules)
      } else if (name === 'categoriesAndZones' && toggledValue) {
        this.unselectTicketingAndTicketingSubmodules(newFormModules)
      } else if (name === 'workshops' && toggledValue) {
        this.unselectTicketingAndTicketingSubmodules(newFormModules)
      } else if (name === 'workshops' && !toggledValue) {
        newFormModules.conferenceMobileApp = false
      } else if (name === 'mobileApp' && toggledValue) {
        this.unselectTicketingAndTicketingSubmodules(newFormModules)
      } else if (name === 'mobileApp' && !toggledValue) {
        newFormModules.conferenceMobileApp = false
        newFormModules.expoMobileApp = false
      } else if (name === 'conferenceMobileApp' && toggledValue) {
        newFormModules.workshops = true
        newFormModules.expoMobileApp = false
      } else if (name === 'expoMobileApp' && toggledValue) {
        newFormModules.conferenceMobileApp = false
      }

      this.$set(this.form, 'modules', newFormModules)
    },
    unselectTicketingSubmodules(modules) {
      modules.floorPlan = false
      modules.ticketPersonalization = false
    },
    unselectTicketingAndTicketingSubmodules(modules) {
      modules.ticketing = false
      this.unselectTicketingSubmodules(modules)
    },

    isSportOrganization() {
      return this.$route.path.includes('/sport-organizations/')
    },

    // Default the tax class to 5% for VAT obligors when nothing valid is selected yet.
    ensureDefaultVat() {
      if (
        this.vatObligor &&
        !this.disableEditing &&
        !this.vatRates.some(rate => rate.value === Number(this.form.VATPercentage))
      ) {
        this.$set(this.form, 'VATPercentage', 5)
      }
    },

    setVat(rate) {
      if (this.disableEditing) {
        return
      }
      this.$set(this.form, 'VATPercentage', rate)
    },

    onSubmitClick() {
      if (
        this.form.modules.mobileApp &&
        !this.form.modules.conferenceMobileApp &&
        !this.form.modules.expoMobileApp
      ) {
        this.snackbar = {
          open: true,
          messageProp: 'workflowsAll.please_select_at_least_one_mobile_app_c1b8ad0',
          color: 'error',
        }

        return
      }

      this.$emit(this.isUpdate ? 'update' : 'submit')
    },
  },
}
</script>

<style scoped>
.event-extra-modules-container {
  margin-top: 3rem;
}
.categories-wrapper {
  margin: 0.5rem 0 1.5rem 0;
  border-radius: 0.5rem;
  border: 1px solid #d9d9d9;
  overflow: hidden;
}
.categories-wrapper__none-module {
  border-radius: 0.5rem;
  border: 1px solid #d9d9d9;
  overflow: hidden;
  margin-top: 5.38rem;
}
.categories-wrapper > *:not(:first-child) {
  border-top: 1px solid #d9d9d9;
}
.buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.title {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #ff4c00;
}
.description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
  margin-bottom: 0;
  margin-top: 0;
}
.inputs {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 0.5rem;
}
.text-field {
  flex-basis: 45%;
}
.tax-class {
  /* No top margin: the Tickets card already has 1.5rem padding-bottom below the
     description, which gives the 24px gap the design expects. */
  margin: 0 1.5rem 24px 3.25rem;
}
.tax-class .description {
  margin-top: 0.125rem;
  color: #666666;
}
.tax-class__options {
  margin-top: 1.25rem;
}
.tax-class__hint {
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  color: #979797;
  margin-top: 0.5rem;
}
.vat-text {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  color: #666666;
  margin-bottom: 0;
}
@media screen and (max-width: 444px) {
  .buttons-wrapper {
    flex-direction: column-reverse;
  }
  .buttons {
    display: flex;
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 600px) {
  .inputs {
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
  }
}
.arrow-back {
  margin-right: 0.625rem;
}
.form-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #ff4c00;
}
.finance-info {
  padding: 0 3.5rem 2rem;
}
.buttons-wrapper--update {
  display: flex;
  justify-content: flex-end;
}
</style>
